module.exports = __webpack_public_path__ + "img/layer6-icon.ad228a5c.png";